import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { guaranteeItems } from "../../data/content";
import { TransformCta } from "../ui/TransformCta";
export function Guarantee() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-163" data-mp="24myc8iijvnmb">
      <div className="mx-auto max-w-3xl text-center" data-id="element-164" data-mp="29eghvjviqcdm">
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-brand-700 text-white ring-8 ring-brand-100" data-id="element-165" data-mp="29g19p1qg7h7s">
          <ShieldCheckIcon className="h-12 w-12" aria-hidden="true" data-id="element-166" data-mp="2jbl4fkta09uy" />
        </div>
        <h2 id="guarantee-title" className="mt-6 font-serif text-[2rem] font-black leading-[1.12] text-ink sm:text-5xl" data-id="element-167" data-mp="2ob7gvs1a5m2p">
          Your <em className="italic text-brand-600" data-id="element-168" data-mp="2sd2heubdzvff">7-day guarantee</em>
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-ink/75" data-id="element-169" data-mp="txg10ascy5yt">
          I want you to be able to explore REFLEXOLOGY 360°™ without unnecessary risk. After purchasing, you'll be able to:
        </p>
      </div>

      <ul className="mx-auto mt-8 grid max-w-2xl grid-cols-1 gap-2.5 sm:grid-cols-2" data-id="element-170" data-mp="3slybwu7s2ler">
        {guaranteeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-brand-50 px-4 py-3.5 text-[17px] font-semibold text-ink" data-id="element-171" data-mp="3ntybl0nspqhn">
            <CheckIcon className="h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-172" data-mp="3itaim9g0azks" />
            {item}
          </li>)}
      </ul>

      <div className="mx-auto mt-8 max-w-2xl text-center text-lg leading-relaxed text-ink/75" data-id="element-173" data-mp="fdvdnmmhjg6i">
        <p data-id="element-174" data-mp="agv59525y1c8">
          If within the first 7 days you decide REFLEXOLOGY 360°™ isn't right for you, you can request a refund according
          to the purchase terms.
        </p>
        <p className="mt-3 font-semibold text-ink" data-id="element-175" data-mp="i5lf6qpi6tc">
          No complicated process. Just a simple guarantee designed to let you explore the system with confidence.
        </p>
      </div>

      <TransformCta label="Try Reflexology 360°™ risk-free for 7 days" data-id="element-176" data-mp="2l84rtbs3s7tu" />
    </section>;
}